export default "__VITE_ASSET__CBZRLE7w__";